module.exports = __webpack_public_path__ + "media/marketing_campaigns/schedule-5b50dd72.svg";